export default "/HostGrotesk-VariableFont_wght.41399a72-a2611c.ttf";